import { createSelector } from 'reselect'
import { flatten } from 'ramda'

import toFixedValue from 'app/common/lib/toFixedValue'

const selectProps = createSelector(
  [
    (_, { items }) => items,
    (_, { kits }) => kits,
    (state) => state.orgs.menu.options.needUpdate,
    (state) => state.orgs.menu.items.loading,
    (state) => state.orgs.dishes.categories.loading,
  ],
  (items, kits, needUpdate, loadingItems, loadingCategories) => {
    const sumAllCosts = (items: Array<{ cost: string }>) =>
      items.reduce(
        (acc, { cost }) => acc + parseFloat(cost.replace(/\s/g, '').replace(',', '.')),
        0.0,
      )

    const itemsSum = sumAllCosts(flatten(items))
    const kitsSum = sumAllCosts(flatten(kits))

    return {
      items,
      kits,
      total: `${toFixedValue(itemsSum + kitsSum) || 0}`,
      needUpdate,
      loading: loadingItems || loadingCategories,
    }
  },
)

export default selectProps
